<script setup lang="ts">

</script>

<template>
  <div class="flex-1 flex flex-col overflow-hidden bg-white p-4 rounded shadow">
    <RouterView/>
  </div>
</template>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
}
</style>
